/**
 * The app's single QueryClient.
 *
 * Extracted out of App.tsx so non-React modules (the axios layer in api.ts) can
 * retire derived caches without importing a page and creating a cycle. It was
 * always a module-level singleton; this only moves where it lives.
 */
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
